import post from "../../../post";
import {review} from "../../../../utils/types";

export const getReviews = () =>
    new Promise((resolve: (reviews: review[]) => void, reject: (error: any) => void) => {
        post('getReviews', {})
            .then(result =>
                resolve(result.data.reviews))
            .catch(reject)
    });